import { render } from "./BaseItineraryPage.vue?vue&type=template&id=ee6f5f44"
import script from "./BaseItineraryPage.vue?vue&type=script&lang=js"
export * from "./BaseItineraryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__